<template lang="html">
  <div class="card-review__container">
    <StarsRating v-if="hasStarRating" :variant="starVariant" :size="starSize" />
    <div class="card-review__text">
      <CustomText v-if="title" weight="bold" size="extraLarge">
        {{ title }}
      </CustomText>
      <span class="card-review__body" v-html="body" />
      <CustomText v-if="user" weight="bold">
        {{ user }}
      </CustomText>
    </div>
    <ExternalLogoIcon v-if="source === 'Facebook'" :name="source" size="large" />
    <ExternalLogo v-else :name="externalLogoName" size="large" />
  </div>
</template>

<script>
import StarsRating from '@/components/common/StarsRating/StarsRating.vue'
import ExternalLogo from '@/components/common/ExternalLogo/ExternalLogo'
import ExternalLogoIcon from '@/components/common/ExternalLogoIcon/ExternalLogoIcon'
import CustomText from '@/components/common/CustomText/CustomText'

export default {
  components: {
    CustomText,
    ExternalLogo,
    ExternalLogoIcon,
    StarsRating
  },

  props: {
    title: {
      type: String,
      default: null
    },
    body: {
      type: String,
      required: true
    },
    user: {
      type: String,
      required: true
    },
    source: {
      type: String,
      required: true,
      validator: (value) => {
        return ['Reddit', 'Trustpilot', 'Reviews.io', 'Facebook'].includes(value)
      }
    }
  },

  computed: {
    externalLogoName () {
      switch (this.source) {
        case 'Reviews.io':
          return 'reviewsio'
        default:
          return this.source
      }
    },

    starSize () {
      switch (this.source) {
        case 'Trustpilot':
          return 'large'
        default:
          return 'medium'
      }
    },

    starVariant () {
      switch (this.source) {
        case 'Reviews.io':
          return 'gradient'
        default:
          return this.source.toLowerCase()
      }
    },

    hasStarRating () {
      return ['Reviews.io', 'Trustpilot'].includes(this.source)
    }
  }
}

</script>

<style lang="scss" scoped>
.card-review {
  &__container {
    padding: $gap * 1.5 $gap;
    background-color: #2C1A48;
    display: flex;
    flex-direction: column;
    gap: $gap * 2;
    border-radius: 8px;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: $gap;
  }

  &__body {
    color: white;

    /deep/ strong {
      font-weight: 400;
      color: white;
      background-color:rgba($colorLightPurple, 0.3);
    }
  }
}
</style>
